import { render, staticRenderFns } from "./forminput.vue?vue&type=template&id=5657a53e&"
import script from "./forminput.vue?vue&type=script&lang=js&"
export * from "./forminput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports